module.exports = __webpack_public_path__ + "static/media/emojis2_24.ae731c73.svg";